/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Využívá Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Využívá AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Obsah je založen na vašich oprávněních a jeho kvalita se může různit.',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Kvalita obsahu se může různit.',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Využívá AI. Výsledky si ověřte.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Informace',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Zahrnout znalosti z aktuální stránky',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Zpět',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Zrušit',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Zrušit',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Zrušit',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Špatná odpověď',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Zpětná vazba byla odeslána',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Dobrá odpověď',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Pokračovat od poslední odpovědi',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopírovat',
  'fabric.editor.ai.config.item.action.responseCopied': 'Zkopírováno',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Zkopírováno do schránky',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Zkusit znovu',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Při vkládání odpovědi se vyskytl problém. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Načtení odpovědi se nezdařilo. Vaše výzva nebo odpověď překročila limit pro tuto žádost. Zavřete dialog a zkuste to znovu.',
  'fabric.editor.ai.experience.apiError': 'Získání odpovědi se nezdařilo, zkuste to znovu.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.commandPaletteV2Placeholder': 'Řekněte AI, co má dělat…',
  'fabric.editor.ai.experience.inputTooShortError':
    'Obsah je pro souhrn příliš krátký. Přidejte další a zkuste to znovu.',
  'fabric.editor.ai.experience.loadingAriaNewTitle': 'Rovo pracuje',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Generuje se',
  'fabric.editor.ai.experience.loadingEditingTitle': 'Rovo upravuje',
  'fabric.editor.ai.experience.previewScreenLabel': 'Náhled',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Řekněte agentovi, aby něco napsal, nebo si vyberte z možností níže.',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Logo Rovo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Zpět',
  'fabric.editor.ai.screens.discard.deleteLabel': 'Odstranit',
  'fabric.editor.ai.screens.discard.discardLabel': 'Zahodit',
  'fabric.editor.ai.screens.discard.keepLabel': 'Zachovat',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Upozornění',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Chyba',
  'fabric.editor.ai.screens.error.cancelLabel': 'Zrušit',
  'fabric.editor.ai.screens.error.closeLabel': 'Zavřít',
  'fabric.editor.ai.screens.error.retryLabel': 'Zkusit znovu',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Živá aktualizace obsahu:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Generování ikony',
  'fabric.editor.ai.screens.noImprovement.noImprovementMessage': 'Žádná vylepšení – pěkná práce!',
  'fabric.editor.ai.screens.noImprovement.successIconLabel': 'Úspěch',
  'fabric.editor.ai.screens.preview.actionButtonsAccept': 'Přijmout',
  'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel': 'Akce pro obsah vygenerovaný AI',
  'fabric.editor.ai.screens.preview.actionButtonsTryAgain': 'Zkusit znovu',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Zrušit',
  'fabric.editor.ai.screens.preview.compactFeedbackText': 'Je to užitečné?',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Řekněte AI, co dělat dál.',
  'fabric.editor.ai.screens.preview.discardLabel': 'Zahodit',
  'fabric.editor.ai.screens.preview.disclaimer': 'Kvalita informací se může různit.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Proč?',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Vymazat',
  'fabric.editor.ai.screens.preview.header.edit': 'Upravit výzvu',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Upravit',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Zeptejte se agenta {agentName}, co dělat dál.',
  'fabric.editor.ai.screens.preview.refineButton': 'Zpřesnit',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Zpřesnit',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Logo Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink': 'Přidat odkaz',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.mention': 'Zmínit uživatele',
  'fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel': 'Vložit formátovaný obsah',
  'fabric.editor.ai.screens.prompt.streaming.placeholder': 'Popište, co chcete dělat.',
  'fabric.editor.ai.screens.prompt.streaming.record': 'Nahrát',
  'fabric.editor.ai.screens.prompt.streaming.submit': 'Odeslat',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Odeslat',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Odeslat do AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} – vybráno',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Odebrat',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Návrhy',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Asistent při psaní',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Nechte si při psaní pomoci od Atlassian Intelligence.',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Psát',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NOVÉ',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Řekněte AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Povědět agentovi',
};
